var scope_0 = require('/home/programmer/projects/arwes-main-website/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b60c0d4272f9ab038ee688853d4e4e9.js').default;
var scope_1 = require('/home/programmer/projects/arwes-main-website/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/147020fa4dea92f3f2f1e356b4237086.js').default;
var scope_2 = require('/home/programmer/projects/arwes-main-website/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6410f398309f23bb0a20c0971aae656e.js').default;
var scope_3 = require('/home/programmer/projects/arwes-main-website/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/898ae6f1ef30dc89def3027d34b0e6a9.js').default;
var scope_4 = require('/home/programmer/projects/arwes-main-website/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ea71d77e628725bf58d9de253b1ea3e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    